module.exports = __webpack_public_path__ + "static/2056812ce0891568f63fdcec5b106e9aac47126bcd327a9d909c8af2ef45aa7d-a6486115bf93aece0ca09411c2806879.jpeg";